module.exports = __webpack_public_path__ + "img/img_article6_tv_play.2f851f09.gif";